import React from "react";
import styled from "styled-components";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

const StyledDropzoneContainer = styled.div`
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
`;

const MainStyledDropzoneText = styled.p`
  margin: 0;
`;

const MainStyledDropzone = ({ onDrop }) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
    },
  });

  return (
    <StyledDropzoneContainer {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <MainStyledDropzoneText>
          {t("Drop the files here ...")}
        </MainStyledDropzoneText>
      ) : (
        <MainStyledDropzoneText>
          {t("Drag 'n' drop some files here, or click to select files")}
        </MainStyledDropzoneText>
      )}
    </StyledDropzoneContainer>
  );
};

export default MainStyledDropzone;
